module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c73b30a718ff08201d4e75846d14d97c.png";